module.exports = __webpack_public_path__ + "images/emoji/chart_with_upwards_trend.b3b0cf6dbeefb54f6925.png";